import { ReactComponent as GamesICon } from "./games.svg";
import { ReactComponent as HomeIcon } from "./home.svg";
import { ReactComponent as LeaderboardIcon } from "./leaderboard.svg";
import { ReactComponent as StoreIcon } from "./store.svg";

export { GamesICon, HomeIcon, LeaderboardIcon, StoreIcon };
